module.exports = __webpack_public_path__ + "img/eyes_male_average.2998ed08.png";